import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close.js";
import Box from "@mui/material/Box/index.js";
import Button from "@mui/material/Button/index.js";
import Checkbox from "@mui/material/Checkbox/index.js";
import FormControlLabel from "@mui/material/FormControlLabel/index.js";
import IconButton from "@mui/material/IconButton/index.js";
import Stack from "@mui/material/Stack/index.js";
import Typography from "@mui/material/Typography/index.js";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import { DatePicker } from "../../../../../components/date-pickers/date-picker/date-picker.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/dialog/dialog.js";
import "@mui/material";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { InvoiceStatus } from "../../no-show-fee-list.types.js";
import { useLabels } from "../../providers/labels.provider.js";
import { useNoShowFilters, initialFilters } from "../../providers/no-show-filters-provider.js";
import { StyledFilterPopover, FiltersContainer } from "./NoShowFeeFilterPopover.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../../type/Translations.js";
import "date-fns/locale";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "color-alpha";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Popover/index.js";
const NoShowFeeFilterPopover = ({ isOpen, anchorEl, onClose }) => {
  var _a;
  const { labels, language } = useLabels();
  const { appliedFilters, setAppliedFilters } = useNoShowFilters();
  const [dateFilter, setDateFilter] = useState(appliedFilters.date);
  const [statusFilter, setStatusFilter] = useState(appliedFilters.status);
  const [reasonFilter, setReasonFilter] = useState(appliedFilters.reason);
  const updateDateFilter = (type, value) => {
    setDateFilter((prev) => ({
      ...prev,
      [type]: value
    }));
  };
  const updateStatusFilter = (status) => {
    setStatusFilter((prev) => {
      if (prev && prev.includes(status)) {
        return prev.filter((s) => s !== status);
      }
      return [...prev || [], status];
    });
  };
  const handleApply = () => {
    setAppliedFilters({
      ...appliedFilters,
      date: dateFilter,
      status: statusFilter,
      reason: reasonFilter
    });
    onClose();
  };
  const handleClear = () => {
    setDateFilter(initialFilters.date);
    setStatusFilter(initialFilters.status);
    setReasonFilter(initialFilters.reason);
    setAppliedFilters(initialFilters);
    onClose();
  };
  const showStatusFilter = !((_a = appliedFilters.status) == null ? void 0 : _a.includes(InvoiceStatus.CANCELLED));
  return /* @__PURE__ */ jsxs(
    StyledFilterPopover,
    {
      open: isOpen,
      anchorEl,
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      children: [
        /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "Lato H5 Bold", children: labels.filter.title }),
          /* @__PURE__ */ jsx(IconButton, { onClick: onClose, disableRipple: true, children: /* @__PURE__ */ jsx(CloseIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxs(FiltersContainer, { spacing: 3, pt: 1, pb: 2, px: 2, children: [
          /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 1", sx: { mb: 1 }, children: labels.filter.date.title }),
            /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 3, children: [
              /* @__PURE__ */ jsx(
                DatePicker,
                {
                  views: ["year", "month", "day"],
                  label: labels.filter.date.from,
                  onChange: (date) => updateDateFilter("fromDate", date),
                  value: dateFilter.fromDate,
                  labels: {
                    cancelButtonLabel: labels.filter.date.cancel,
                    okButtonLabel: labels.filter.date.apply
                  },
                  language
                }
              ),
              /* @__PURE__ */ jsx(
                DatePicker,
                {
                  views: ["year", "month", "day"],
                  label: labels.filter.date.to,
                  onChange: (date) => updateDateFilter("toDate", date),
                  value: dateFilter.toDate,
                  labels: {
                    cancelButtonLabel: labels.filter.date.cancel,
                    okButtonLabel: labels.filter.date.apply
                  },
                  language
                }
              )
            ] })
          ] }),
          showStatusFilter && /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 1", sx: { mb: 2 }, children: labels.filter.paymentStatus.title }),
            /* @__PURE__ */ jsxs(Stack, { children: [
              /* @__PURE__ */ jsx(
                FormControlLabel,
                {
                  control: /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      checked: statusFilter == null ? void 0 : statusFilter.includes(InvoiceStatus.PAID),
                      onChange: () => updateStatusFilter(InvoiceStatus.PAID)
                    }
                  ),
                  label: labels.filter.paymentStatus.paid
                }
              ),
              /* @__PURE__ */ jsx(
                FormControlLabel,
                {
                  control: /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      checked: statusFilter == null ? void 0 : statusFilter.includes(InvoiceStatus.OPEN),
                      onChange: () => updateStatusFilter(InvoiceStatus.OPEN)
                    }
                  ),
                  label: labels.filter.paymentStatus.open
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", justifyContent: "flex-end", gap: 2, p: 3 }, children: [
          /* @__PURE__ */ jsx(Button, { onClick: handleClear, variant: "borderless", children: labels.filter.clear }),
          /* @__PURE__ */ jsx(Button, { onClick: handleApply, disabled: !(statusFilter == null ? void 0 : statusFilter.length), variant: "filled", children: labels.filter.apply })
        ] })
      ]
    }
  );
};
export {
  NoShowFeeFilterPopover as default
};
